import { de, type Dict } from './de'
import { en } from './en'

export type Language = 'de' | 'en'

/** Verschachtelte Pfade zu String-Blätter, z. B. 'nav.tracking' oder 'workspace.roles.owner'. */
type Leaves<T> = T extends object
    ? {
          [K in keyof T & string]: T[K] extends string
              ? K
              : `${K}.${Leaves<T[K]>}`
      }[keyof T & string]
    : never

export type DictPath = Leaves<Dict>

const dicts: Record<Language, Dict> = { de, en }

/**
 * Reine Übersetzungsfunktion — auch außerhalb von React nutzbar
 * (z. B. lib/errors.ts). Unbekannte Platzhalter bleiben unverändert.
 */
export function translate(
    language: Language,
    key: DictPath,
    params?: Record<string, string | number>,
): string {
    const value = key.split('.').reduce<unknown>(
        (node, part) => (node as Record<string, unknown> | undefined)?.[part],
        dicts[language],
    )
    let text = typeof value === 'string' ? value : key
    if (params) {
        for (const [name, val] of Object.entries(params)) {
            text = text.split(`{${name}}`).join(String(val))
        }
    }
    return text
}
